module.exports = __webpack_public_path__ + "img/icb-empty-m@3x.45295d0c.png";